/* eslint-disable @next/next/no-img-element */

import { UiKitButtonBase } from '@/fo/ui/kit/button/base';

import { styles } from './UiToastAdded.styles';

export interface UiToastAddedProps {
  src: string;
  subtitle: string;
  title: string;
  buttonText: string;
  /** Ссылка кнопки. Если задана, кнопка рендерится как Link */
  buttonHref?: string;
  /** Обработчик клика по кнопке. Используется, если не задан buttonHref */
  onButtonClick?: () => void;
}

export function UiToastAdded({
  src,
  subtitle,
  title,
  buttonText,
  buttonHref,
  onButtonClick
}: UiToastAddedProps) {
  const slots = styles();

  return (
    <div className={slots.base()}>
      <div className={slots.imageWrapper()}>
        <img
          className={slots.image()}
          src={src}
          alt={subtitle}
        />
      </div>
      <div className={slots.contentWrapper()}>
        <div className={slots.content()}>
          <div className={slots.title()}>{title}</div>
          <div
            className={slots.subtitle()}
            dangerouslySetInnerHTML={{ __html: subtitle }}
          />
          {buttonHref ? (
            <UiKitButtonBase
              as="link"
              href={buttonHref}
              color="secondary"
            >
              {buttonText}
            </UiKitButtonBase>
          ) : (
            <UiKitButtonBase
              color="secondary"
              onClick={onButtonClick}
            >
              {buttonText}
            </UiKitButtonBase>
          )}
        </div>
      </div>
    </div>
  );
}
